import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from '../service/language.service';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

    constructor(private languageService: LanguageService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const cloned = req.clone({
            headers: req.headers.set('Accept-Language', this.languageService.getCurrent()),
        });

        return next.handle(cloned);
    }
}
